/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateEmbeddingDto
 */
export interface CreateEmbeddingDto {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateEmbeddingDto
     */
    input: Array<string>;
}

/**
 * Check if a given object implements the CreateEmbeddingDto interface.
 */
export function instanceOfCreateEmbeddingDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "input" in value;

    return isInstance;
}

export function CreateEmbeddingDtoFromJSON(json: any): CreateEmbeddingDto {
    return CreateEmbeddingDtoFromJSONTyped(json, false);
}

export function CreateEmbeddingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEmbeddingDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'input': json['input'],
    };
}

export function CreateEmbeddingDtoToJSON(value?: CreateEmbeddingDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'input': value.input,
    };
}

